import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "product"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
    key: 0,
    class: "well"
};
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import { useContent } from '@/composables/useContent';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductPage',
    setup(__props) {
        const route = useRoute();
        useAuth();
        const { getProduct } = useContent();
        const product = ref(null);
        function nav() {
            window.location = product.value.websiteUrl;
        }
        onMounted(() => {
            getProduct(route.params.id, (p) => {
                product.value = p;
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    bgcolor: "transparent",
                    border: "0"
                }),
                _createVNode(CustomerLoadWait, { customer: product.value }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (product.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", {
                                    class: "productImg",
                                    style: _normalizeStyle('background-image: url(' + product.value.backgroundImage + ')')
                                }, null, 4),
                                _createElementVNode("h2", null, _toDisplayString(product.value.title), 1),
                                _createElementVNode("h1", null, _toDisplayString(product.value.subTitle), 1),
                                _createElementVNode("h2", null, _toDisplayString(product.value.intro), 1),
                                _createElementVNode("p", {
                                    innerHTML: product.value.description.replaceAll('</h2>\n\n', '</h2>\n').replaceAll('\n', '<br/>')
                                }, null, 8, _hoisted_2),
                                (product.value.bodyListItems && product.value.bodyListItems.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.bodyListItems.split(','), (t) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                class: "tick",
                                                key: t
                                            }, _toDisplayString(t), 1));
                                        }), 128))
                                    ]))
                                    : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.paragraphs, (p) => {
                                    return (_openBlock(), _createElementBlock("div", { key: p }, [
                                        _createElementVNode("h2", null, _toDisplayString(p.title), 1),
                                        _createElementVNode("p", null, _toDisplayString(p.body), 1)
                                    ]));
                                }), 128)),
                                _createVNode(MGButton, {
                                    fullWidth: true,
                                    text: product.value.actionButtonText,
                                    onClick: nav
                                }, null, 8, ["text"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
